import { styled } from "@linaria/react";
import { ReactNode } from "react";
import { COLOR_GRAY_LIGHTER, COLOR_PURPLE, COLOR_WHITE } from "../../constants";
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1honu7l"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c1kqma61"
});
const AnimationContainer = /*#__PURE__*/styled("div")({
  name: "AnimationContainer",
  class: "a16cy874"
});

function Balloon(props: {
  children: ReactNode;
}): JSX.Element {
  return <Container>
      <Content>
        <AnimationContainer>{props.children}</AnimationContainer>
      </Content>
    </Container>;
}

export default Balloon;

require("../../../.linaria-cache/src/components/balloon/index.linaria.module.css");